/**
 * 대화 속 장면 줄 (시안 03 README 5.15, 프로토타입 카운터의 isRustle · isSmall · isSummaryDone).
 *
 * - rustle: 가운데 기울인 글씨 「(가게 뒤쪽에서 웃음소리가 들린다)」 + 문틈 사진 카드(annex-gap)
 * - aside: 다른 멤버의 곁말. 표식 20 + 「손 팀장 · 」 + 부리 글씨
 * - posted: 유저가 확인하고 올린 말. 오른쪽, 「별채에 올릴 말」
 * - imoCard: 이모 명함 카드(이모 소개 뒤). 누르면 onOpenProfile
 * - birth_entry: 카운터 장부 시트에서 적은 생일. 내 말풍선에 문장으로(시안 14 L5), 지웠으면 「생일을 장부에서 지웠어요」
 *
 * 안전 카드와 이모의 사주 재요청 카드, 재방문 차 칩은 부르는 쪽이 그립니다.
 */
import { ChevronRight } from 'lucide-react';
import { MEMBERS } from '@config/members/index.js';
import { Avatar } from './Avatar.jsx';
import { MyMessage } from './MessageBubbles.jsx';
import { BIRTH_ENTRY_DELETED, formatBirthLine } from './birth/birthLine.js';

export function SceneLine({ scene, onOpenProfile = null }) {
    if (scene.type === 'rustle') {
        return (
            <div className="flex flex-col items-center gap-2 py-1">
                <span className="text-caption text-text-secondary italic">{scene.text}</span>
                <img
                    src="/assets/scenes/annex-gap.jpg"
                    alt="가게 뒤 별채 문틈으로 불빛과 사람들 그림자가 보인다"
                    width={300}
                    height={150}
                    loading="lazy"
                    className="h-[150px] w-[300px] max-w-full rounded-[14px] object-cover"
                    style={{ objectPosition: 'center 40%' }}
                />
            </div>
        );
    }
    if (scene.type === 'aside') {
        const member = MEMBERS[scene.memberKey];
        return (
            <div className="flex items-center gap-1.5 self-center py-0.5">
                <Avatar memberKey={scene.memberKey} size={20} />
                <span className="text-caption text-text-secondary">{member?.name} · </span>
                <span className="font-serif text-[14px]">{scene.text}</span>
            </div>
        );
    }
    if (scene.type === 'posted') {
        return (
            <div className="flex max-w-[84%] flex-col items-end gap-1 self-end">
                <span className="text-micro font-normal text-label-muted">별채에 올릴 말</span>
                <p className="m-0 rounded-card border border-hairline bg-surface px-3.5 py-2.5 text-[15px] leading-6 whitespace-pre-wrap">
                    {scene.text}
                </p>
            </div>
        );
    }
    if (scene.type === 'birth_entry') {
        return <MyMessage body={formatBirthLine(scene.birth) ?? BIRTH_ENTRY_DELETED} />;
    }
    if (scene.type === 'imoCard') {
        const imo = MEMBERS.imo;
        return (
            <button
                type="button"
                onClick={onOpenProfile ?? undefined}
                disabled={!onOpenProfile}
                aria-label={`${imo.name} 소개 보기`}
                className="ml-10 flex items-center gap-3 rounded-card border border-hairline bg-surface p-3 text-left"
            >
                <Avatar memberKey="imo" size={56} />
                <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                    <span className="text-[15px] font-semibold">{imo.name}</span>
                    <span className="text-[13px] leading-[18px] text-text-secondary">
                        {imo.role} · {imo.line}
                    </span>
                </span>
                <ChevronRight size={20} strokeWidth={1.6} aria-hidden="true" className="text-text-secondary" />
            </button>
        );
    }
    return null;
}
